import { useRef, useEffect, useState } from "react";

import "./index.css";

function ImageWidget(props) {
  const [imgSrc, setImgSrc] = useState("");

  useEffect(() => {
    if (props.image && props.image.length > 0) {
      setImgSrc(props.image);
    }
  }, []);

  return (
    <div className="EmployeeReaderWidget ImageEmployeeReaderWidget">
      {imgSrc && imgSrc.length > 0 &&
        <div className="ImageWidgetContentImgContainer">
          <div
            style={{ backgroundImage: `url(${imgSrc})` }}
            className="ImageWidgetContentImg"
          />
        </div>
      }
    </div>
  )
}

export { ImageWidget };
